<template>
  <IQOS class="gap-row-xs" :title="$t('worker_profile.bot_panel_title')" required>
    <div class="gap-column-xs bot-info-container">
      <img class="iqos-qrcode-image notif-qrcode" :src="qrCodeSrc" v-if="deeplink_id" />
      <div class="status-block gap-row-xs">
        <div class="telegram-status-block gap-column-1xs">
          <BaseIcon icon="telegram-bold" size="lg"/>
          <div>
            <p class="qrw-label-sm v1-grey-10-color">QRWaiter Bot</p>
            <p class="v1-grey-7-color" v-if="!waiter.personal_telegram_id">
              {{ $t("workers_table.bot_not_connected") }}
            </p>
            <p class="red-4-color" v-else-if="!waiter.is_online">
              {{ $t("worker_profile.bot_offline") }}
            </p>
            <p class="green-5-color" v-else>
              {{ $t("workers_table.bot_connected") }}
            </p>
          </div>
        </div>
        <p class="iqos-comment qrw-paragraph-md">
          {{ $t("worker_profile.bot_panel_comment") }}
        </p>
      </div>
    </div>
     <a class="bot-link qrw-paragraph-md green-5-color" target="_blank" :href="directLink">
        {{ directLink }}
      </a>
  </IQOS>
</template>

<script>
import IQOS from "@/components/IQOS.vue";

import WaitersAPI from "@/api/waiters";

export default {
  data() {
    return {
      deeplink_id: null,
    };
  },
  props: {
    waiter: Object,
  },
  methods: {
    fetchDeeplink() {
      WaitersAPI.getDeeplink(this.waiter._id)
        .then((data) => {
          this.deeplink_id = data.deeplink;
        })
        .catch((error) => {});
    },
  },
  computed: {
    qrCodeSrc() {
      return `https://api.qrserver.com/v1/create-qr-code/?size=168x168&data=https://t.me/QRWaiterPersonalBot?start=${this.deeplink_id}`;
    },
    directLink() {
      return `https://t.me/QRWaiterPersonalBot?start=${this.deeplink_id}`;
    }
  },
  mounted() {
    this.fetchDeeplink();
  },
  components: {
    IQOS,
  },
};
</script>

<style scoped>
.telegram-status-block {
  align-content: center;
  align-items: center;
}

.notif-qrcode {
  min-width: 160px;
  max-width: 160px;
  width: 160px;
  height: 160px;
  min-height: 160px;
  border-radius: 4px;
  border: 4px solid var(--white-color);
}

.bot-info-container {
  align-items: center;
  align-content: center;
}

.bot-link {
  text-decoration: none;
}
</style>
